
<template>
    <!-- 弹窗 -->
    <div class="granary-popup" v-show="dialogShow" @touchmove.prevent @mousewheel.prevent>
      <div class="popup">
        <p class="pop-close">
          <span @click="closePopupHander"></span>
        </p>
        <div class="pop-title">扫码提示</div>
        <p class="pop-desc">揭开罐底第一层二维码，积分码在第二层噢，扫描领取积分好礼～</p>
        <div class="pop-img">
          <img src="../../assets/images/babyGranary/SweepTips.png" alt="">
        </div>
        <div class="popCon">
          <p class="pop-bottom">积分宝藏<br/> 在罐底</p>
          <p class="pop-bottom">揭开第一<br/> 层溯源码</p>
          <p class="pop-bottom">第二层才<br/> 是积分码</p>
        </div>
        <div class="pop-btn" @click="weiScanSHnader">继续扫码</div>
      </div>
    </div>
</template>
<style lang="less" scoped>
//弹窗
  .granary-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 999;
    .popup {
      width: 300px;
      height: 356px;
      border-radius: 8px;
      background: @expertFontColor255;
      position: fixed;
      top: 0;bottom: 0;
      left: 0;right:0;margin:auto;
      .pop-close {
        text-align: right;
        padding-top: 10px;
        padding-right: 10px;
        span {
          display: inline-block;
          width: 21px;
          height: 21px;
          background: url(../../assets/images/babyGranary/close.jpg) no-repeat
            center center;
          background-size: 13px 13px;
        }
      }
      .pop-title {
        font-size: @indexFontSize18;
        font-weight: bold;
        color: rgba(52, 55, 58, 1);
        line-height: 18px;
        text-align: center;
        margin-top: 10px;
      }
      .pop-desc {
        width: 238px;
        font-size:@indexFontSize12;
        color: rgba(34, 34, 34, 1);
        line-height: 18px;
        margin: 17px auto 8px;
        text-align: center;
      }
      .pop-img {
        width: 100%;
        height: 87px;
        background-size: auto 100%;
        margin: 14px auto 1px;
        img{
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 0 14px;
        }
      }
      .popCon{
        width: 274px;
        margin: 0 auto;
        overflow: hidden;
        p:nth-child(2){
          padding:0 5px;
        }
        text-align: center;
        .pop-bottom {
          width: 88px;
          font-size:@indexFontSize12;
          color: @mainColor;
          line-height:16px;
          text-align: center;
          float: left;
          margin-top: 10px;
          font-weight:500;
        }
      }
      .pop-btn {
        width: 140px;
        height: 36px;
        background: linear-gradient(
          270deg,
          rgba(212, 164, 55, 1) 0%,
          rgba(229, 191, 93, 1) 100%
        );
        border-radius: 23px;
        font-size: @indexFontSize18;
        color: @expertFontColor255;
        line-height: 36px;
        text-align: center;
        margin: 24px auto 0;
      }
    }
  }
</style>
<script>
export default {
    name:"toTop",
    props:["dialogShow"],
    data() {
        return {
            
        }
    },
    mounted(){
        
    },
    methods:{
        closePopupHander() {
            this.$emit("closeDialog",this.dialogShow);
        },
        weiScanSHnader:function(){
          this.$emit("wxScanFn");
        }
    }
}
</script>